import * as Sentry from "@sentry/react";
import { Fn_activeAxios } from "../function/FnConfig";
import { fn_log_error } from "function/FnPosBridge";

export async function select_shopcd_by_token(rootStore) {
  const searchStore = rootStore.searchStore;
  let data = JSON.stringify({ token: searchStore.getSession.tk });

  const api = Fn_activeAxios(rootStore);

  let res = await api
    .post("/gate/okgo/check_token", data, {
      headers: await getAxiosHeaderJson(),
    })
    .then(res => {
      if (res.data.resultCode === "000") {
        const data = res.data.data;
        if (data && data.shopCd && data.user_name) {
          rootStore.searchStore.setStSessionShopCd(data.shopCd, data.user_name);
          return data.shopCd;
        } else {
          return "err";
        }
      } else {
        return "err";
      }
    })
    .catch(err => {
      return "err";
    });

  return res;
}

export function getCheckTokenValid(rootStore) {
  if (!getNullCheck(rootStore.searchStore.getToken)) {
    return false;
  }
  if (!getTokenTimeCheck(rootStore.searchStore.getTokenExpireIn)) {
    return false;
  }

  return true;
}

export function getNullCheck(data) {
  if (data == undefined || data == null || data == "null" || data == "") {
    return false;
  }

  return true;
}

export function getTokenTimeCheck(time) {
  if (!getNullCheck(time)) return false;

  let tempTime = parseInt(time);

  return tempTime / 3600 < 1 ? false : true;
}

// 토큰 새로 발급
export async function select_access_token(rootStore, type = true) {
  const url = "/gate/public/get_tokens";
  const { searchStore } = rootStore;

  if (type) {
    if (getCheckTokenValid(rootStore)) {
      return searchStore.getToken;
    }
  }
  let userName = searchStore.getSession.user_name;
  if (userName === null || userName.trim() === "" || userName === undefined) {
    return;
  }

  let data = JSON.stringify({
    username: searchStore.getSession.user_name,
    password: searchStore.getSession.user_name,
  });

  const api = Fn_activeAxios(rootStore);
  try {
    const res = await api.post(url, data, {
      headers: getAxiosHeaderJson(),
    });
    if (res.data.resultCode === "000") {
      const data = res.data.data;
      if (data.access_token) {
        localStorage.setItem("token", "");
        localStorage.setItem("token", data.access_token);
        searchStore.setStSessionToken(data.access_token);
        searchStore.setStSessionExpireIn(data.expires_in);
        return res;
      }
    }
  } catch (error) {
    Sentry.withScope((scope) => {
      scope.setTag("type", "auth");
      scope.setTag("api_url", url);
      scope.setContext("Token Refresh Error", {
        message: "Failed to get new access token.",
        username: userName,
      });
      Sentry.captureException(error);
    });
    rootStore.layerStore.setLayerLoadingView(false);
    return "err";
  }
}

export function getAxiosHeaderJson() {
  return { "Content-Type": "application/json" };
}

export async function getAxiosHeader(rootStore) {
  await select_access_token(rootStore).then(token => {
    if (!token || token === "err") {
      // 인증 실패
      rootStore.layerStore.setLayerAlertType("err_access_token");
      rootStore.layerStore.setLayerAlertView(true);
    }
  });
}
